'use client';

import Link from 'next/link';

export default function StorefrontError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4 py-16">
      {/* Icon */}
      <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mb-6">
        <svg width="28" height="28" viewBox="0 0 256 256" fill="#dc2626">
          <path d="M236.8 188.09L149.35 36.22a24.76 24.76 0 00-42.7 0L19.2 188.09a23.51 23.51 0 000 23.72A24.35 24.35 0 0040.55 224h174.9a24.35 24.35 0 0021.33-12.19 23.51 23.51 0 00.02-23.72zM120 104a8 8 0 0116 0v40a8 8 0 01-16 0zm8 88a12 12 0 1112-12 12 12 0 01-12 12z" />
        </svg>
      </div>

      <h1 className="text-2xl font-bold text-foreground mb-2">
        حدث خطأ غير متوقع
      </h1>

      <p className="text-sm text-muted-foreground mb-8 max-w-sm leading-relaxed">
        نعتذر عن هذا الخلل. لا تقلق، بياناتك آمنة وفريقنا يعمل على حل المشكلة.
      </p>

      <div className="flex items-center gap-3">
        <button
          onClick={reset}
          className="inline-flex items-center justify-center rounded-xl bg-primary text-primary-foreground font-semibold py-2.5 px-6 text-sm hover:bg-primary/90 transition-colors"
        >
          إعادة المحاولة
        </button>
        <Link
          href="/"
          className="inline-flex items-center justify-center rounded-xl border border-border bg-background text-foreground font-semibold py-2.5 px-6 text-sm hover:bg-muted transition-colors"
        >
          العودة للرئيسية
        </Link>
      </div>
    </div>
  );
}
